<template>
  <div class="main" v-loading="loading">
    <div class="hot-title">
      <dl>
        <!--        <dd @click="check(1)" :class="[timeActive === 1 ? 'active' : '']">-->
        <!--          热门精选-->
        <!--        </dd>-->
        <dd @click="check(2)" :class="[timeActive === 2 ? 'active' : '']">
          话题精选
        </dd>
      </dl>
    </div>
    <div id="dbTable" class="listTable">
      <div v-for="(item, indexList) in getData" :key="indexList">
        <!--      <div class="lineBox"></div>-->
        <div class="main-box" @click="go(item.guid)">
          <div class="content">
            <div>
              <ul>
                <li>
                  <span :title="item.title"> {{ item.title }}</span>
                </li>
                <li>
                  {{ introSub(item.intro, 50) }}
                </li>
              </ul>
            </div>
            <div>
              <img
                :src="imageShowUrl(item.coverImage)"
                @error="imgError(item)"
              />
            </div>
          </div>

          <div class="foot">
            <div>
              <span class="head-img"><img :src="item.headImage"/></span
              >{{ item.name ? item.name : "豆瓣用户" }}
              <span style="margin-left: 25px">{{ item.addTime }}</span>
            </div>
            <div class="right">
              <div class="good">{{ item.likeCount }}</div>
              <span>{{ item.commentCount }} 回应</span>
              <span>{{ item.forwardCount }} 推荐</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next, jumper"
      :total="rowCount"
      :current-page="pageable.pageIndex"
      :page-size="pageable.pageSize"
      :pager-count="5"
      @current-change="goPage"
      hide-on-single-page
    ></el-pagination>
  </div>
</template>

<script>
import { Pageable } from "../../assets/script/model";
import { mapActions } from "vuex";

export default {
  name: "DouBanList",
  data() {
    return {
      timeActive: 2,
      loading: false,
      rowCount: 0,
      getData: []
    };
  },
  computed: {
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    },
    pageable: {
      get() {
        return this.$store.state.hotList.Pageable;
      },
      set(val) {
        this.$store.state.hotList.Pageable = val;
      }
    }
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.getHotLineHeight(val, "dbTable", 35);
      }
    }
  },
  created() {
    this.pageable = new Pageable(1, 20);
    this.getTopData();
  },
  mounted() {
    this.getid = setInterval(() => {
      let getBox = document.getElementById("dbTable");
      if (getBox) {
        clearInterval(this.getid);
        this.getHotLineHeight(this.contentHeight, "dbTable", 35);
      }
    }, 500);
  },
  methods: {
    ...mapActions("hotList", ["ADouBan"]),
    check(type) {
      if (type) {
        this.timeActive = type;
      }
    },
    go(guid) {
      this.$router.push("/article/detail/" + guid);
    },
    async getTopData() {
      this.loading = true;
      let result = await this.ADouBan(Object.assign(this.pageable));
      if (result.errorCode === 0) {
        this.rowCount = result.data.rowCount;
        if (result.data.dataSource) {
          this.getData = result.data.dataSource;
        }
      } else {
        this.$message({ message: result.errorMess, type: "error" });
      }
      this.loading = false;
    },
    introSub(intro, num) {
      let length = intro.length;
      intro = intro.trim().substring(0, num);
      if (length > num) {
        intro = intro + "...";
      }
      return intro;
    },
    goPage(pageIndex) {
      this.pageable.pageIndex = pageIndex;
      this.getTopData();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/mixin";
.pageIndex();
.main {
  /*padding-right: 10px;*/
  width: 460px;
  font-size: 12px;
  background-color: white;
  .listTable {
    height: 300px;
    width: 100%;
    overflow: auto;
    overscroll-behavior-y: contain;
    padding-right: 10px;
  }
  .main-box {
    cursor: pointer;
    /*margin-top: 10px;*/
    border-top: 1px dashed #c3c3c3;
    padding-top: 10px;
    padding-bottom: 10px;
    .content {
      display: flex;
      div {
        &:nth-child(2) {
          margin-left: -10px;
          img {
            width: 100px;
            height: 80px;
            margin-left: 20px;
          }
        }
        &:nth-child(1) {
          /*padding-right: 15px;*/
          color: #999;
          line-height: 26px;
        }
        li {
          width: 330px;
          &:nth-child(1) {
            color: #5c5c5c;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          &:nth-child(2) {
            margin-top: 5px;
          }
          a {
            color: #999;
          }
        }
      }
    }
    .foot {
      color: #999;
      margin-top: 10px;
      padding-right: 10px;
      div {
        display: inline-block;
        span {
          margin-left: 30px;
          &:nth-child(1) {
            margin-left: 0;
          }
        }
      }
      .right {
        float: right;
      }
      .good {
        padding-left: 15px;
        background: url("../../assets/image/hot/heart.png") no-repeat 0;
      }
    }
    .head-img {
      width: 20px;
      height: 20px;
      float: left;
      border-radius: 50%;
      background: #ccc;
      margin-right: 8px;
      margin-top: -2px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    &:hover {
      background-color: #f5f8ff;
    }
  }
  .hot-title {
    /*margin-bottom: 10px;*/
    dl,
    dd {
      display: inline-block;
      margin-right: 10px;
    }
    dl {
      color: #5c5c5c;
      dd {
        padding: 10px 10px;
        height: 25px;
        line-height: 3px;
        cursor: pointer;
      }
    }
    height: 35px;
    .active {
      background: #ebf3fe;
      border-radius: 20px;
      color: @theme-color;
      border: 1px solid #d9d9dc;
    }
  }
}
</style>
